import apiClient from './client';

export const fetchDashboard = async () => {
  const response = await apiClient.get('/dashboard');
  return response.data;
};

export const fetchChildProgress = async (childId) => {
  const response = await apiClient.get(`/children/${childId}/progress`);
  return response.data;
};

export const fetchChildDailyActivities = async (childId, date) => {
  const response = await apiClient.get(`/children/${childId}/daily_activities`, {
    params: { date }
  });
  return response.data;
};

export const approveSkipRequest = async (path) => {
  const response = await apiClient.post(path);
  return response.data;
};

export const rejectSkipRequest = async (path) => {
  const response = await apiClient.post(path);
  return response.data;
};

export const fetchChildActivities = async (childId) => {
  const response = await apiClient.get(`/children/${childId}/activities`);
  return response.data;
};

export const fetchChildActivityScores = async (childId, activityId) => {
  const response = await apiClient.get(`/children/${childId}/activities/${activityId}/scores`);
  return response.data;
};
